import { useTranslation } from 'react-i18next';
import { EyeIcon } from '@heroicons/react/24/outline';

import type { ui } from '@procuros/datachecks';
import type { SuccessfulEnrichment } from 'hooks/useGruAgent/types';

import { SingleSparkleIcon } from 'components/CustomIcons/SingleSparkleIcon';
import { EnrichmentActionDetails } from 'components/WebEDI/EnrichmentActionDetails/EnrichmentActionDetails';

import { AgentMessageCard } from '../AgentMessageCard/AgentMessageCard';

type EnrichDocumentAgentCardProps = {
  agentProposal: SuccessfulEnrichment;
  isApplied: boolean;
  uiConfig: Array<ui.Section> | undefined;
  canonical: Record<string, unknown> | undefined | null;
  onPreview: (jqExpression: string) => void;
  onApply: () => void;
};

export const EnrichDocumentAgentCard = ({
  agentProposal,
  isApplied,
  uiConfig,
  canonical,
  onPreview,
  onApply,
}: EnrichDocumentAgentCardProps) => {
  const { t } = useTranslation();

  if (isApplied) {
    return <EnrichmentActionDetails agentProposal={agentProposal} uiConfig={uiConfig} canonical={canonical} />;
  }

  const title = t('webedi:sidebar.agents.enrichDocuments.title');
  const subtitle = t('webedi:sidebar.agents.enrichedCount', { count: agentProposal.payload.enriched_count });

  return (
    <AgentMessageCard
      title={title}
      subtitle={subtitle}
      description={agentProposal.payload.summary}
      actions={[
        {
          label: t('webedi:sidebar.agents.applyEnrichmentButton'),
          LeftIcon: SingleSparkleIcon,
          variant: 'ai',
          onClick: onApply,
          analyticsId: `webedi:agent_apply_enrichment`,
        },
        {
          label: t('webedi:sidebar.agents.previewButton'),
          LeftIcon: EyeIcon,
          variant: 'secondary',
          onClick: () => onPreview(agentProposal.payload.jqExpression),
          analyticsId: `webedi:agent_preview_enrichment`,
        },
      ]}
    />
  );
};
